<template>
    <div class="service-header">
        <div class="header-tabs">
            <div class="tabs">
                <div style="text-align:center;margin-top:54px"><span style="font-size:20px">服务器安装包</span></div>
                <div style="display:flex;justify-content: center;margin-top:36px">
                    <div class="beijing2" @mousemove="getsg()" @mouseleave="getgss()" @click="getwxia()">
                        <div style="text-align:center">
                            <img src="@/assets/image/beijng3.png" alt="" style="width:100px;" class="imgs" v-if="ind ==0">
                            <img src="@/assets/image/xiaz.png" alt="" style="width:100px;" class="imgs" v-else-if="ind ==1">
                        </div>
                        <p style="margin-top:64px"><span style="font-size:19px;color:#fff">Windows安装包</span></p>
                    </div>
                    <div class="beijing3" style="margin-left:25px" @mousemove="getsg1()" @mouseleave="getgss1()" @click="getlwxia()">
                        <div style="text-align:center">
                            <img src="@/assets/image/lux.png" alt="" style="width:100px;" v-if="ind1 ==0">
                            <img src="@/assets/image/xiaz.png" alt="" style="width:100px;" v-else-if="ind1 ==1">
                        </div>
                        <p style="margin-top:64px"><span style="font-size:19px;color:#fff">Linux安装包</span></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="kehu">
            <span style="font-size: 16px;color: #5B5B5B;text-align:center;display:inline-block;width:100%;margin-top:60px">服务器安装包使用引导</span>
            <div style="display: flex;justify-content: space-around;">
              <div class="ktabs">
                <div style="text-align:center;margin-top:40px">
                    <img src="@/assets/image/yi.png" alt="" style="vertical-align: middle;">
                    <span style="font-size:16px;margin-left:10px;vertical-align: middle;">服务器安装</span>
                </div>
                <div style="text-align:center;margin-top:53px">
                    <img src="@/assets/image/mian.png" alt="" style="margin-top:5px">
                </div>
                <div style="margin-left:36px;margin-top:63px" >
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>根据服务器操作系统下载安装包，参考手册安装</p>
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>配置服务器相关IP和端口，并启动服务器 </p>
                </div>
            </div>
            <div class="ktabs">
                <div style="text-align:center;margin-top:40px">
                    <img src="@/assets/image/er.png" alt="" style="vertical-align: middle;">
                    <span style="font-size:16px;margin-left:10px;vertical-align: middle;">用户管理</span>
                </div>
                <div style="text-align:center;margin-top:53px">
                    <img src="@/assets/image/yiren.png" alt="">
                </div>
                <div style="margin-left:36px;margin-top:13px">
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>使用管理员账号admin登录系统</p>
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>添加用户账号并设置角色和权限</p>
                </div>
            </div>
            <div class="ktabs">
                <div style="text-align:center;margin-top:40px">
                    <img src="@/assets/image/san.png" alt="" style="vertical-align: middle;">
                    <span style="font-size:16px;margin-left:10px;vertical-align: middle;">开始会议</span>
                </div>
                <div style="text-align:center;margin-top:53px">
                    <img src="@/assets/image/sanren.png" alt="">
                </div>
                <div style="margin-left:36px;margin-top:20px">
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>用户下载客户端并使用账号信息登录并开始会议</p>
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>会议结束后，系统可以查看会议的统计信息</p>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            ind:0,
            ind1:0,
        }
    },
    methods:{
        getsg(){
             this.ind = 1
        },
        getgss(){
             this.ind = 0
        },
         getsg1(){
             this.ind1 = 1
        },
        getgss1(){
             this.ind1 = 0
        },
        getwxia(){
            const a = document.createElement('a')
            document.body.appendChild(a)
            a.style = 'display: none'
            a.href = 'http://www.hongshanmeeting.com/download/HongshanMeeting_WindowsBox.zip'
            a.click()
            window.URL.revokeObjectURL(url)
        },
        getlwxia(){
            const a = document.createElement('a')
            document.body.appendChild(a)
            a.style = 'display: none'
            a.href = 'http://www.hongshanmeeting.com/download/HongshanMeeting_LinuxBox.zip'
            a.click()
            window.URL.revokeObjectURL(url)
        }
    }
}
</script>
<style lang="scss">
    .service-header{
        width: 1240px;
        margin: 0 auto;
        position: relative;
        top:300px;
        .header-tabs{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            .tabs{
               width: 1188px;
               height: 588px;
               background: url('../../assets/image/beitu.png');
               box-shadow: 0 0 5px 3px rgba(14, 113, 235, 0.15);
               border-radius: 20px;
               .beijing2{
                   width: 304px;
                   height: 386px;
                   background: url('../../assets/image/beijing2.png');
                   text-align: center;
                   display: flex;
                   flex-direction: column;
                   justify-content: center;
                   cursor: pointer;
               }
               .beijing3{
                   width: 304px;
                   height: 386px;
                   background: url('../../assets/image/beijing2.png');
                   text-align: center;
                   display: flex;
                   flex-direction: column;
                   justify-content: center;
                cursor: pointer;
               }
            }
        }
        .kehu{
            .ktabs{
                width: 386px;
                height: 447px;
                background: #FFFFFF;
                border: 1px solid #CAD9FF;
                border-radius: 10px;
                margin-top: 20px;
            }
        }
    }
</style>